// extracted by mini-css-extract-plugin
module.exports = {"paymentsContainer":"payments_paymentsContainer__2Hex4"};